import * as React from 'react';
import {Menu, Typography, Card, Button, Col, message} from 'antd';
import {useEffect, useState} from 'react';

function CountDownButton(props: {title: string; onClick: () => any; loading?: boolean; countDown: number; label?: string; alwaysEnable?: boolean}) {
  const [countDown, setCountDown] = useState(0);

  useEffect(() => {
    if (countDown !== 0) {
      setTimeout(() => {
        setCountDown(countDown - 1);
      }, 1000);
    }
  }, [countDown]);
  return (
    <Button
      loading={props.loading}
      disabled={!props.alwaysEnable && countDown > 0}
      type={'primary'}
      onClick={async () => {
        try {
          await props.onClick();
          setCountDown(props.countDown);
        } catch (e) {
          message.error(e.message);
        }
      }}>
      {countDown > 0 ? `${countDown}s 后${props.label || '再试'}` : props.title}
    </Button>
  );
}
export default CountDownButton;
